/**
 * Telegram Mini App platform adapter — stub.
 *
 * Real implementation will use `@telegram-apps/sdk-react`:
 *   - `initData` for authenticated user identity (signature verified server-side)
 *   - `themeParams` and `colorScheme` for theme
 *   - `viewportStableHeight` and `safeAreaInset` for layout
 *   - `HapticFeedback` for `vibrate`
 *   - `shareURL` for `share`
 *   - `BackButton.onClick` for `onBack`
 *   - `CloudStorage` for persistent storage (mirrored to server)
 *
 * Reference: https://docs.telegram-mini-apps.com/
 *
 * Until wired, this stub throws on construction — the platform selector
 * routes to `webAdapter` whenever TG runtime is absent.
 */
import type { PlatformAdapter } from './adapter.js';

export function createTelegramAdapter(): PlatformAdapter {
  throw new Error(
    'createTelegramAdapter is not yet implemented. ' +
      'Install @telegram-apps/sdk-react and wire it here. ' +
      'See ARCHITECTURE.md → PlatformAdapter section.',
  );
}

/**
 * Detect whether we are running inside the Telegram WebApp runtime.
 * The TG runtime injects `window.Telegram.WebApp` early in page load.
 */
export function isTelegramRuntime(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const tg = (window as unknown as { Telegram?: { WebApp?: unknown } }).Telegram;
  return tg?.WebApp !== undefined;
}
